module.exports = __webpack_public_path__ + "img/i4.a893b065.jpg";